import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import FobHighwayEditingDialog from '../DialogEditingType/FobHighwayEditingDialog';
import { ROLE_ADMIN, ROLE_ENGINNER } from '../../../Constants/ConstantsOptics';
import { FOB, FOB_FLAG } from '../../../Constants/ConstantsOptics';
import ModalDescriptionComponentSpecifically from '../../../Modal/ModalDescriptionComponentSpecifically';
import DialogFobFoto from '../DialogFoto/DialogFobFoto';
import { fetchFobFileCount } from '../CountFile/FileCount';
import { fetchFobConnectionCount } from '../CountFile/ConnectionCount';

const FobHighwayDialog = ({  open, onClose, content, snackbarOpen, snackbarMessage, snackbarClass,
  handleCloseSnackbar, copyToClipboard, role, user, highwayRefresh,
  groupedCoordinatesWithColorTypeAndWidth, wellData, fobLocationData, couplingLocationData, ponBoxLocationData, pillarData, setIsComponentСhangeCoorFob}) => {

  const [openModalEditing, setOpenModalEditing] = useState(false);
  const [openModalDescription, setOpenModalDescription] = useState(false);
  const [openModalFoto, setOpenModalFoto] = useState(false);
  const [fileCount, setFileCount] = useState(0);
  const [connectionCount, setConnectionCount] = useState(0);

 const openModalDescriptionComponents = () => {
  if(connectionCount != 0){
    setOpenModalDescription(true);
 }
 };
 
 const openModalFotoFile = () => {
    if(fileCount != 0){
      setOpenModalFoto(true);
    }
  }; 

  const openModalEditingContent = () => {
    setOpenModalEditing(true);
  };  

  useEffect(() => {
    const updateFileCount = async () => {  
      const count = await fetchFobFileCount(content.id);
      if (count !== null) {
        setFileCount(count); 
      }
    };
    updateFileCount();
  });

  useEffect(() => {
    const updateConnectionCount = async () => {  
      const count = await fetchFobConnectionCount(content.id);
      if (count !== null) {
        setConnectionCount(count); 
      }
    };
    updateConnectionCount();
  });

  return (
    <Dialog open={open} onClose={onClose} className="dialogStyle">
    <DialogContent>
    {content.rankComponentId === 1 || content.rankComponentId === 2 ? (
           <img src='./fob.png' width='30' height='30' style={{ marginRight: "5px" }} />
            ) : (
            <img src='./fob_canton.png' width='30' height='30' style={{ marginRight: "5px" }} />
    )}
    <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset',textShadow: '2px 2px 4px #3d3d3d'}}>Фоб</label>
    <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe',textShadow: '2px 2px 4px #3d3d3d' }}>{content.id}</span></label>
      <Button 
          style={{marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
          onClick={() => { copyToClipboard(content.id, "фоб"); }}>
          <FileCopyIcon style={{ color: '#e4c253'}}/>
        </Button>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Территория: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.city}</span> </label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Фоб: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.fobName}</span> </label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Мax ранг линка: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.rankComponentName}</span> </label>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Внес: <span style={{ color: '#bebebe',fontWeight: 'normal' ,textShadow: '2px 2px 4px #3d3d3d'}}>{content.authorId}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Дата добавления: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{new Date(content.createDate).toISOString().slice(0, 19).replace("T", " ")}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Комментарий: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.description}</span></label>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 

      <button onClick={openModalDescriptionComponents} class='buttonIsConnectionDialog' style={{textShadow: '2px 2px 4px #3d3d3d'}}>
        Связи
          <span className={`countCircle ${connectionCount > 0 ? 'green' : 'red'}`}>
            {connectionCount > 0 ? connectionCount : 'нет'}
          </span>
        </button>

      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 

      <button onClick={openModalFotoFile} className='buttonIsConnectionDialog' style={{textShadow: '2px 2px 4px #3d3d3d'}}>
        Просмотр файлов
        <span className={`countCircle ${fileCount > 0 ? 'green' : 'red'}`}>
           {fileCount > 0 ? fileCount : 'нет'}
        </span>
      </button>     

      <hr className='horizontalLineDialog'/>
    </DialogContent>

    <DialogActions>
     {((user === content.authorId && role.role === ROLE_ENGINNER) || role.role === ROLE_ADMIN) && (
      <Button onClick={openModalEditingContent} class='buttonIsEditDialog'>
          Редактировать
      </Button>
    )}
      <Button onClick={onClose} class='buttonIsHideDrawer23'>
        Закрыть
      </Button>
    </DialogActions>

      {/* Snackbar */}
      <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />

       {/* Modal Foto*/}
       <DialogFobFoto
          open={openModalFoto}
          onClose={() => setOpenModalFoto(false)}
          id={content.id}     
      />    

        <ModalDescriptionComponentSpecifically
          open={openModalDescription}
          onClose={() => setOpenModalDescription(false)}
          id={content.id}
          type={FOB}
          flag={FOB_FLAG}
          groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
          wellData={wellData}
          fobLocationData={fobLocationData}
          couplingLocationData={couplingLocationData}
          ponBoxLocationData={ponBoxLocationData}
          pillarData={pillarData}
        />

       {/* Modal редактирование FobHighway*/}
       <FobHighwayEditingDialog
        open={openModalEditing}
        onClose={() => setOpenModalEditing(false)}
        onClose2={onClose}
        content={content}
        user={user}
        highwayRefresh={highwayRefresh}
        groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
        wellData={wellData}
        fobLocationData={fobLocationData}
        couplingLocationData={couplingLocationData}
        ponBoxLocationData={ponBoxLocationData}
        pillarData={pillarData}
        setIsComponentСhangeCoorFob={setIsComponentСhangeCoorFob}
      />     
  </Dialog>
  );
}

export default FobHighwayDialog;